/* eslint-disable react-refresh/only-export-components */
import { ComponentType, Dispatch, SetStateAction } from 'react';
import { PanelFeatureEnum, PointOfInterest } from '@/__generated__/graphql';
import { Comments } from '@/components/shared/Comments';
import { Logs } from '../Logs/Logs';
import Stack from '@mui/material/Stack/Stack';
import { Typography } from '@mui/material';
import { ComponentReports } from '@/components/Analysis/ReviewScreen/ComponentReviewPanelReports/ComponentReports';
import { SectionMedia } from '@/components/Analysis//shared/MediaUploadsAndViewer/SectionMedia';
import { ScreenshotLocationType } from '@/types';

export type PanelFeatureProps = {
  poi: PointOfInterest;
  isUpdating?: boolean;
  setIsUpdating?: Dispatch<SetStateAction<boolean>>;
  handleCaptureView?: (location: ScreenshotLocationType) => Promise<void>;
  sectionKey: string;
};

const CommentsFeature = ({ poi }: PanelFeatureProps) => (
  <Stack flex={1}>
    <Comments referenceId={poi.id} collectionName="pointOfInterests" />
  </Stack>
);

const LogsFeature = ({ poi }: PanelFeatureProps) => (
  <Logs referenceId={poi.id} collectionName="PointOfInterest" poiType={poi.type} isLogsTab />
);

const ReportListFeature = ({ poi }: PanelFeatureProps) => {
  const assemblyId = poi.assembly?.id;
  if (!assemblyId) {
    return (
      <Stack>
        <Typography color="text.secondary">No component found for this POI.</Typography>
      </Stack>
    );
  }

  return (
    <ComponentReports
      componentId={assemblyId}
      pointOfInterestId={poi.id}
      initialTab="POINT_OF_INTEREST"
      hideTabs
    />
  );
};
const SectionMediaFeature = ({ poi, isUpdating, setIsUpdating, sectionKey }: PanelFeatureProps) => (
  <SectionMedia
    selectedPoiInfo={poi}
    sectionKey={sectionKey}
    setIsUpdating={setIsUpdating}
    isUpdating={isUpdating}
  />
);

export const panelFeatureRegistry: Record<PanelFeatureEnum, ComponentType<PanelFeatureProps>> = {
  [PanelFeatureEnum.Comments]: CommentsFeature,
  [PanelFeatureEnum.Logs]: LogsFeature,
  [PanelFeatureEnum.ReportList]: ReportListFeature,
  [PanelFeatureEnum.Attachments]: SectionMediaFeature,
  [PanelFeatureEnum.AllAttachments]: SectionMediaFeature,
};
